/**
 * Flattens whatever the api/* layer threw into one human-readable line.
 *
 * Every helper in api/* ends with `throw error.response?.data || error.message`, so what arrives
 * here is usually DRF's own error payload -- `{ field: ["message"] }` from a serializer, DRF's
 * `{ detail: "..." }`, or the `{ error: "..." }` shape our own views return by hand. Handing any
 * of those straight to console.error prints a useless collapsed "Object" in a production console
 * (and tells the user nothing in a toast), which is exactly when the details matter most.
 *
 * Returns '' when there's nothing recognisable to say, so callers can fall back to their own
 * generic wording.
 */
export function formatApiError(error) {
    if (error === null || error === undefined) return '';
    if (typeof error === 'string') return error;
    if (typeof error !== 'object') return String(error);
    if (Array.isArray(error)) {
        return error.map(formatApiError).filter(Boolean).join('; ');
    }
    if (typeof error.detail === 'string') return error.detail;
    if (typeof error.error === 'string') return error.error;
    // A plain Error (network failure, thrown string) rather than a serializer payload.
    if (error instanceof Error) return error.message;
    return Object.entries(error)
        .map(([field, value]) => {
            const text = formatApiError(value);
            if (!text) return '';
            return field === 'non_field_errors' ? text : `${field}: ${text}`;
        })
        .filter(Boolean)
        .join('; ');
}

export default formatApiError;
